import { MODAL_FORM } from 'constants/form';

export const AC_LED_MAPPING_ROUTE = '/ac-led-mapping';
export const AC_LED_MAPPING_ROUTE_V2 = '/ac-led-mapping/v2';

export const MAPPING_FILTERS_TYPES = {
  DROPDOWN: 'dropdown',
};

export const MAPPING_FILTERS_CONFIG_KEY = 'teacher_supply_filters';
export const AC_LED_MAPPING_FILTERS_KEY = 'ac_led_mapping_filters';
export const AC_LED_MAPPING_REJECTION_REASONS_KEY = 'ac_led_mapping_rejection_reasons';
export const AC_MAPPING_CONFIG = 'ac_mapping_config';

export const AC_LED_MAPPING_MODAL_TYPES = {
  BASIC_CONFIRMATION_MODAL: 'basic_confirmation_modal',
};

export const AC_LED_MAPPING_MODAL_TYPES_CONFIG = {
  [AC_LED_MAPPING_MODAL_TYPES.BASIC_CONFIRMATION_MODAL]: {
    modalCode: MODAL_FORM.AC_LED_MAPPING_BASIC_CONFIRMATION_MODAL,
  },
};

export const AC_LED_MAPPING_EVENTS = {
  SEARCH_STUDENT: 'SEARCH_STUDENT',
  SEARCH_TEACHERS_FOR_STUDENT: 'SEARCH_TEACHERS_FOR_STUDENT',
  BOOK_DEMO_SLOT: 'BOOK_DEMO_SLOT',
  REJECT_RECOMMENDED_TEACHERS_CLICK: 'REJECT_RECOMMENDED_TEACHERS_CLICK',
  REJECT_RECOMMENDED_TEACHERS_REASON_FILL: 'REJECT_RECOMMENDED_TEACHERS_REASON_FILL',
};

export const MAPPER_TYPE = {
  MAPPER: 'MAPPER',
  AC: 'ACADEMIC_COUNSELLOR',
};
